module.exports = __webpack_public_path__ + "img/faith.797b1d0e.png";